import { GoogleMap, GoogleMarkerClusterer, InfoWindowF, Marker, MarkerF, useJsApiLoader } from "@react-google-maps/api";
import React, { useCallback, useEffect, useState } from "react";
import PIN_IMG from "../assets/images/pin.png";
import "./index.scss";
import { Button, Form } from "react-bootstrap";
import { DistrictList, ProvinceList, ProvinceModel } from "../model/province.model";
import TextField from '@mui/material/TextField';
import { Divider, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import NO_RESULT_IMG from "../assets/images/no-result.png";
import { SearchResultModel } from "../model/search-result.model";
import STORE_LIST_JSON from "../assets/json/store-list-update.json";
import MARKER_ALL_JSON from "../assets/json/marker-all.json";
import PRODUCT_LIST_JSON from "../assets/json/product-list.json";
import { ProductListModel } from "../model/product-list.model";
import { MarkerModel } from "../model/marker.model";
import ApiServices from "../services/api.service";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faStar } from "@fortawesome/free-solid-svg-icons";
const thai = require('thai-data')


export const KEY_GOOGLE = "AIzaSyAAXobY8r6Hpkh4xQx6CZY-16nqFBiIpbA";
const IndexComponent = () => {
    const [provinceModel, setProvinceModel] = useState<ProvinceModel[]>()
    const [provinceAll, setProvinceAll] = useState<ProvinceList[]>()
    const [districtAll, setDistrictAll] = useState<DistrictList[]>()
    const [distrioctSelect, setDistrictSelect] = useState<DistrictList[]>();
    const [provinceValue, setProvinceValue] = useState("");
    const [districtValue, setDistrictValue] = useState("");
    const [productValue, setProductValue] = useState("999");
    const [map, setMap] = useState<any>(null)
    const [searchResult, setSearchResult] = useState<SearchResultModel[]>();
    const [recommendStoer, setRecommendStore] = useState<SearchResultModel[]>();
    const [storeList, setStoreList] = useState<SearchResultModel[]>();
    const [productList, setProductList] = useState<ProductListModel[]>(PRODUCT_LIST_JSON);
    const [markerModel, setMarkerModel] = useState<MarkerModel[]>();
    const [currentMarker, setCurrentMarker] = useState(0);
    const [selectedMarker, setSelectedMarker] = useState<MarkerModel>();
    const [currentLocation, setCurrentLocation] = useState<GeolocationPosition>();
    const mapStyles: React.CSSProperties = {
        width: '100%',
    };

    useEffect(() => {

        if (currentLocation) {
            reInitialMarkerwithDistance();
        }
    }, [currentLocation])


    useEffect(() => {
        if (!provinceModel) {
            setProvinceModel(thai.getAllData())

        } else {
            const provinceListMod: ProvinceList[] = new Array;
            provinceModel.map((item: ProvinceModel, index: any) => {
                if (item.provinceList) {
                    item.provinceList!.map((province: ProvinceList, indexProvice: number) => {
                        const provinceList: ProvinceList = province;
                        provinceListMod.push(provinceList);

                    })
                }
            })
            removeDistinct(provinceListMod)
            getAllDistrict();
        }
    }, [provinceModel])

    useEffect(() => {

        if (markerModel && map) {
            const bounds = new window.google.maps.LatLngBounds(markerModel[0]);

            map.fitBounds(bounds);
            map.setZoom(10)
            // initialPlaceIdService();

        }

    }, [markerModel && map])

    useEffect(() => {
        if (selectedMarker) {
            console.log(selectedMarker);
        }
    }, [selectedMarker])

    useEffect(() => {
        if (provinceAll && searchResult) {
            createMarker();
        }
    }, [provinceAll])

    useEffect(() => {
        if (!searchResult) {
            const searchMod: SearchResultModel[] = new Array();
            const sorted = STORE_LIST_JSON.sort((a, b) => Number(b.store_recommend) - Number(a.store_recommend));
            const recommedMod: SearchResultModel[] = new Array();
            sorted.filter((item) => item.store_status && item.store_recommend).map((value: SearchResultModel, index: number) => {
                recommedMod.push(value);
            })
            STORE_LIST_JSON.filter((item) => item.store_status).map((value: SearchResultModel, index: number) => {
                searchMod.push(value);
            })
            console.log("Length Total: " + searchMod.length)
            setSearchResult(searchMod);
            setRecommendStore(recommedMod);
            setStoreList(searchMod);
        }
    }, [searchResult])

    const createMarker = () => {
        const markerMod: MarkerModel[] = new Array();
        if (searchResult) {
            if (currentLocation) {

                if (searchResult.length == 0 && recommendStoer) {
                    recommendStoer.sort((a, b) => Number(a.distance)! - Number(b.distance)!).map((item: SearchResultModel, index: number) => {
                        let lat = 0;
                        let lng = 0;
                        if (item.store_lat_lng && item.store_location_url) {
                            lat = Number(item.store_lat_lng.split(",")[0]);
                            lng = Number(item.store_lat_lng.split(",")[1]);

                            if (item.store_id == 232) {
                                console.log(lat + ", " + lng);
                            }
                            let marker: MarkerModel = {
                                description: item.store_address + "",
                                id: item.store_id,
                                lat: lat,
                                lng: lng,
                                name: item.store_name,
                                url: item.store_location_url + "",
                                photos: item.store_photo_url + ""
                            }
                            if (currentLocation) {
                                const distance = calculateDistance(currentLocation.coords.latitude, currentLocation.coords.longitude
                                    , lat, lng); // Berlin to Paris
                                item.distance = distance.toFixed(2);
                            }
                            markerMod.push(marker);
                        }



                    })
                } else {
                    searchResult.sort((a, b) => Number(a.distance)! - Number(b.distance)!).map((item: SearchResultModel, index: number) => {
                        let lat = 0;
                        let lng = 0;
                        if (item.store_lat_lng && item.store_location_url) {
                            lat = Number(item.store_lat_lng.split(",")[0]);
                            lng = Number(item.store_lat_lng.split(",")[1]);

                            if (item.store_id == 232) {
                                console.log(lat + ", " + lng);
                            }
                            let marker: MarkerModel = {
                                description: item.store_address + "",
                                id: item.store_id,
                                lat: lat,
                                lng: lng,
                                name: item.store_name,
                                url: item.store_location_url + "",
                                photos: item.store_photo_url + ""
                            }
                            if (currentLocation) {
                                const distance = calculateDistance(currentLocation.coords.latitude, currentLocation.coords.longitude
                                    , lat, lng); // Berlin to Paris
                                item.distance = distance.toFixed(2);
                            }
                            markerMod.push(marker);
                        }

                    })

                }
                setMarkerModel(markerMod)

            }
        }

    }

    const reInitialMarkerwithDistance = () => {

        if (markerModel && searchResult && currentLocation && recommendStoer) {

            const newState = searchResult.map((obj: SearchResultModel) => {
                let lat = 0;
                let lng = 0;
                if (obj.store_lat_lng) {
                    lat = Number(obj.store_lat_lng.split(",")[0]);
                    lng = Number(obj.store_lat_lng.split(",")[1]);
                }
                // 👇️ if id equals 2, update country property
                const distance = calculateDistance(currentLocation.coords.latitude, currentLocation.coords.longitude
                    , lat, lng); // Berlin to Paris
                return { ...obj, distance: distance.toFixed(2) + "km" };
            });
            const newStateRecommend = recommendStoer.map((obj: SearchResultModel) => {
                let lat = 0;
                let lng = 0;
                if (obj.store_lat_lng) {
                    lat = Number(obj.store_lat_lng.split(",")[0]);
                    lng = Number(obj.store_lat_lng.split(",")[1]);
                }
                // 👇️ if id equals 2, update country property
                const distance = calculateDistance(currentLocation.coords.latitude, currentLocation.coords.longitude
                    , lat, lng); // Berlin to Paris
                return { ...obj, distance: distance.toFixed(2) + "km" };
            });
            setRecommendStore(newStateRecommend)
            setSearchResult(newState);
            initialPlaceIdService();
        }

    }
    const initialPlaceIdService = () => {
        if (markerModel && searchResult && recommendStoer) {
            const markerMod = [...markerModel];
            searchResult.map((item: SearchResultModel, index: number) => {
                let lat = 0;
                let lng = 0;
                if (item.store_lat_lng) {
                    lat = Number(item.store_lat_lng.split(",")[0]);
                    lng = Number(item.store_lat_lng.split(",")[1]);

                    const items: MarkerModel = {
                        description: item.store_address + "",
                        id: item.store_id,
                        lat: lat,
                        lng: lng,
                        name: item.store_name,
                        url: item.store_location_url + "",
                        photos: item.store_photo_url + ""
                    }
                    markerMod.push(items);
                }

            })
            recommendStoer.map((item: SearchResultModel, index: number) => {
                let lat = 0;
                let lng = 0;
                if (item.store_lat_lng) {
                    lat = Number(item.store_lat_lng.split(",")[0]);
                    lng = Number(item.store_lat_lng.split(",")[1]);

                    const items: MarkerModel = {
                        description: item.store_address + "",
                        id: item.store_id,
                        lat: lat,
                        lng: lng,
                        name: item.store_name,
                        url: item.store_location_url + "",
                        photos: item.store_photo_url + ""
                    }
                    markerMod.push(items);
                }

            })
            setMarkerModel(markerMod);
            // markerMod.map((item: MarkerModel, index: number) => {
            //     var request = {
            //         query: item.name,
            //         fields: ['name', 'geometry', 'place_id', 'photos'],
            //     };
            //     var service = new google.maps.places.PlacesService(map);
            //     service.findPlaceFromQuery(request, (results: any, status) => {
            //         if (results && status === google.maps.places.PlacesServiceStatus.OK) {
            //             for (var i = 0; i < results.length; i++) {
            //                 if(results.length > 0){
            //                     if(results[i].photos && results[i].photos.length > 0){
            //                         item.photos = results[i].photos[0].getUrl({ 'maxWidth': 200, 'maxHeight': 200 })
            //                     }
            //                 }

            //             }
            //         }
            //     });
            //     markerMod.push(item);
            // })
            // console.log(markerMod);
            // setMarkerModel(MARKER_ALL_JSON)
        }

    }

    const submit = () => {
        if (storeList) {
            const searchMod: SearchResultModel[] = new Array();
            storeList.map((item: SearchResultModel, index: number) => {

                const province_id = searchProviceIdByName(item.store_province);
                const district_id = searchDistrictIdByName(item.store_district);
                if (provinceValue && provinceValue != "888" && districtValue && productValue) {
                    console.log(item.store_province)
                    if (item.store_province && provinceAll && districtAll) {

                        if (province_id) {
                            if (Number(province_id) == Number(provinceValue) && Number(district_id) == Number(districtValue)) {

                                if (Number(productValue) == 999) {
                                    console.log(item);
                                    searchMod.push(item)
                                } else {
                                    if (item.product_category_id) {
                                        item.product_category_id.map((pd: number, indexPD: number) => {
                                            if (pd == Number(productValue)) {
                                                console.log(item);
                                                searchMod.push(item)
                                            }
                                        })
                                    }

                                }

                            }
                        }
                    }

                } else if (provinceValue && provinceValue != "888" && districtValue) {
                    if (provinceAll && districtAll) {
                        if (province_id) {
                            if (Number(province_id) == Number(provinceValue) && Number(district_id) == Number(districtValue)) {
                                console.log(item);
                                searchMod.push(item)
                            }
                        }
                    }

                }
                else if (provinceValue && provinceValue != "888" && productValue) {

                    if (provinceAll) {
                        if (province_id) {
                            if (Number(province_id) == Number(provinceValue)) {
                                if (Number(productValue) == 999) {
                                    console.log(item);
                                    searchMod.push(item)
                                } else {
                                    if (item.product_category_id) {
                                        item.product_category_id.map((pd: number, indexPD: number) => {
                                            if (pd == Number(productValue)) {
                                                searchMod.push(item)
                                            }
                                        })
                                    }

                                }
                            }
                        }

                    }

                } else if (provinceValue && provinceValue != "888") {
                    if (provinceAll) {
                        if (province_id) {
                            if (Number(province_id) == Number(provinceValue)) {
                                console.log(item);
                                searchMod.push(item)
                            }
                        }
                    }
                } else if (productValue) {
                    if (Number(productValue) == 999) {
                        searchMod.push(item)
                    } else {
                        if (item.product_category_id) {
                            item.product_category_id.map((pd: number, indexPD: number) => {
                                if (pd == Number(productValue)) {
                                    searchMod.push(item)
                                }
                            })
                        }

                    }

                }
                else {
                    searchMod.push(item);
                }

                setSearchResult(searchMod);


            })
        }


    }

    const searchProviceIdByName = (name) => {
        let provinceName = name;

        if (provinceAll) {
            const provineL = provinceAll.filter((itemProvince) => itemProvince.provinceName == provinceName)[0]

            if (provineL && provineL.provinceId) {
                return provineL.provinceId;
            } else {
                return 0;
            }
        }
    }


    const searchDistrictIdByName = (name) => {
        let districtName = name;

        if (districtAll) {
            const provineL = districtAll.filter((itemProvince) => itemProvince.districtName == districtName)[0]
            if (provineL && provineL.districtId) {
                return provineL.districtId;
            } else {
                return 0;
            }
        }
    }

    const getAllDistrict = () => {
        if (provinceModel) {
            const districtMod: DistrictList[] = new Array;
            provinceModel.map((item: ProvinceModel, index: any) => {
                if (item.districtList) {
                    item.districtList!.map((district: DistrictList, indexProvice: number) => {
                        const districtList: DistrictList = district;
                        districtMod.push(districtList);

                    })
                }
            })
            removeDistinctDistrict(districtMod);
        }

    }
    const removeDistinctDistrict = (districtMod: DistrictList[]) => {
        if (districtMod) {
            // Identify the property (e.g., 'name') that determines uniqueness
            const propertyName = 'districtName';

            // Use the filter method to remove distinct values
            const filteredData = districtMod.filter((item, index, arr) => {
                // Find the index of the current item in the array
                const currentIndex = arr.findIndex((obj) => obj[propertyName] === item[propertyName]);

                // If the current index is not the same as the index where the item was initially found, it's a duplicate (distinct)
                return currentIndex === index;
            });


            filteredData.sort((a, b) => a.districtName.localeCompare(b.districtName))
            setDistrictAll(filteredData);
        }

    }
    const removeDistinct = (provinceListMod: ProvinceList[]) => {
        if (provinceListMod) {
            // Identify the property (e.g., 'name') that determines uniqueness
            const propertyName = 'provinceId';

            // Use the filter method to remove distinct values
            const filteredData = provinceListMod.filter((item, index, arr) => {
                // Find the index of the current item in the array
                const currentIndex = arr.findIndex((obj) => obj[propertyName] === item[propertyName]);

                // If the current index is not the same as the index where the item was initially found, it's a duplicate (distinct)
                return currentIndex === index;
            });

            filteredData.sort((a, b) => a.provinceName.localeCompare(b.provinceName))
            setProvinceAll(filteredData);
        }

    }

    const searchDistrctbyProviceId = (provinceId) => {
        if (districtAll) {
            const districtMod: DistrictList[] = new Array();
            districtAll.map((item: DistrictList, index: number) => {

                if (item.proviceId == provinceId) {
                    districtMod.push(item)
                }
            })
            setDistrictSelect(districtMod);
        }
    }

    function MapComponent() {
        let infoWindow: google.maps.InfoWindow;
        const { isLoaded } = useJsApiLoader({
            id: 'google-map-script',
            googleMapsApiKey: KEY_GOOGLE,
            libraries: ["places"],

        })


        const onLoad = React.useCallback((map: any) => {
            // This is just an example of getting and using the map instance!!! don't just blindly copy!
            infoWindow = new google.maps.InfoWindow();
            const locationButton = document.createElement("button");

            locationButton.textContent = "Pan to Current Location";
            locationButton.classList.add("custom-map-control-button");

            map.controls[google.maps.ControlPosition.TOP_CENTER].push(locationButton);
            if (markerModel) {
                console.log(markerModel[currentMarker]);
            }
            setMap(map);
            locationButton.addEventListener("click", () => {
                // Try HTML5 geolocation.
                if (navigator.geolocation) {
                    console.log("Click my location")
                    navigator.geolocation.getCurrentPosition(
                        (position: GeolocationPosition) => {
                            const pos = {
                                lat: position.coords.latitude,
                                lng: position.coords.longitude,
                            };

                            infoWindow.setPosition(pos);
                            infoWindow.setContent("Location found.");
                            infoWindow.open(map);
                            map.panTo(pos)
                            map.setCenter(pos);
                            map.setZoom(17);

                        },
                        () => {
                            handleLocationError(true, infoWindow, map.getCenter()!);
                        }
                    );
                } else {
                    // Browser doesn't support Geolocation
                    handleLocationError(false, infoWindow, map.getCenter()!);
                }
            });
        }, [])

        function handleLocationError(
            browserHasGeolocation: boolean,
            infoWindow: google.maps.InfoWindow,
            pos: google.maps.LatLng
        ) {
            infoWindow.setPosition(pos);
            infoWindow.setContent(
                browserHasGeolocation
                    ? "Error: The Geolocation service failed."
                    : "Error: Your browser doesn't support geolocation."
            );
            infoWindow.open(map);
        }

        const onUnmount = React.useCallback(() => {
            setMap(null)
        }, [])

        return isLoaded ? (
            markerModel &&
            <GoogleMap
                mapContainerClassName="googlemap-view-control"
                mapContainerStyle={mapStyles}
                zoom={14}
                center={markerModel[currentMarker]}
                options={{
                    minZoom: 7,
                    maxZoom: 17
                }}
                onLoad={onLoad}
                onUnmount={onUnmount}
            >
                {markerModel.map((item: MarkerModel, index) => (
                    <MarkerF
                        key={index}
                        position={new google.maps.LatLng(item.lat, item.lng)}
                        icon={{ url: PIN_IMG, scaledSize: new google.maps.Size(50, 50) }}
                        onClick={() => clickMarker(item)}
                    // You can add more options for each marker here
                    />
                ))}
                {selectedMarker && (
                    <InfoWindowF
                        position={{ lat: selectedMarker.lat, lng: selectedMarker.lng }}
                        onCloseClick={() => setSelectedMarker({} as MarkerModel)}
                    >
                        <div className="googlemap-info-window">
                            <img className="googlemap-info-window-img" src={selectedMarker.photos}></img>
                            <h2 className="googlemap-info-window-title">{selectedMarker.id} - {selectedMarker.name}</h2>
                            <p className="googlemap-info-window-desc">{selectedMarker.description}</p>

                            <Button onClick={() => clicktoDirection(selectedMarker.url)}>นำทาง</Button>
                        </div>
                    </InfoWindowF>
                )}
                <></>
            </GoogleMap>

        ) : <></>
    }

    const onTextChange = (value, action) => {
        console.log(value);
        if (action == 'province') {
            if (value == 888) {
                setProvinceValue("888");
                searchDistrctbyProviceId("");
            } else {
                setProvinceValue(value);
                searchDistrctbyProviceId(value);

            }
            setDistrictValue("")
            setProductValue("999");
        } else if (action == 'district') {
            setDistrictValue(value);
            setProductValue("999");
        } else if (action == 'product') {
            setProductValue(value);
        }
    }

    const returnProductCategoryByID = (id) => {
        const value = productList.filter(item => item.product_category_id == id);
        if (value.length > 0) {
            return value[0].product_category_name
        } else {
            return "-"
        }
    }

    const returnProductUrlByID = (id) => {
        const value = productList.filter(item => item.product_category_id == id);
        if (value.length > 0) {
            return value[0].product_url
        } else {
            return "-"
        }
    }

    const OpenProductUrl = (id) => {
        returnProductUrlByID(id)
        window.open(returnProductUrlByID(id), "_blank");
    }

    useEffect(() => {
        if (!currentLocation) {
            if ("geolocation" in navigator) {
                navigator.geolocation.getCurrentPosition((position: GeolocationPosition) => {
                    // Access granted, and position object contains latitude and longitude
                    const latitude = position.coords.latitude;
                    const longitude = position.coords.longitude;
                    setCurrentLocation(position)
                    // You can call a function or perform other actions with the coordinates here
                }, function (error) {
                    // Access denied or an error occurred
                    switch (error.code) {
                        case error.PERMISSION_DENIED:
                            console.error("User denied the request for Geolocation.");
                            break;
                        case error.POSITION_UNAVAILABLE:
                            console.error("Location information is unavailable.");
                            break;
                        case error.TIMEOUT:
                            console.error("The request to get user location timed out.");
                            break;
                    }
                });
            } else {
                // Geolocation is not available in this browser
            }

        }

    },)

    useEffect(() => {

        submit();
    }, [productValue, provinceValue, districtValue])

    useEffect(() => {

        if (searchResult) {
            createMarker();
        }
    }, [searchResult]);

    const clicktoDirection = (url) => {
        if (currentLocation) {
            window.open(url, '_blank');
        }
    }

    const clickMarker = (index) => {

        const markerSelect = index as MarkerModel;
        setSelectedMarker(markerSelect);
        if (markerModel && map) {
            map.setZoom(17)
            map.panTo({ lat: markerSelect.lat, lng: markerSelect.lng })
            map.setCenter({ lat: markerSelect.lat, lng: markerSelect.lng })
        }

    }

    const clickBranch = (item, index) => {
        const markerSelect = item as SearchResultModel;
        if (markerModel && map) {
            console.log(markerSelect);
            // setCurrentMarker(index);
            map.setZoom(17)
            let lat = 0;
            let lng = 0;
            if (item.store_lat_lng && item.store_location_url) {
                lat = Number(item.store_lat_lng.split(",")[0]);
                lng = Number(item.store_lat_lng.split(",")[1]);
                map.panTo({ lat: lat, lng: lng })
                // map.setCenter({ lat: lat, lng: lng })
            }

        }
    }

    function calculateDistance(lat1, lon1, lat2, lon2) {
        const R = 6371; // Radius of the Earth in kilometers
        const dLat = degToRad(lat2 - lat1);
        const dLon = degToRad(lon2 - lon1);
        const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(degToRad(lat1)) *
            Math.cos(degToRad(lat2)) *
            Math.sin(dLon / 2) *
            Math.sin(dLon / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        const distance = R * c; // Distance in kilometers
        return distance;
    }

    function degToRad(deg) {
        return deg * (Math.PI / 180);
    }

    return (
        <div className="googlemap-control">
            <div className="googlemap-top-control">
                <div className="googlemap-form-control">

                    <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                        <InputLabel id="googlemap-form-label">จังหวัด</InputLabel>
                        <Select
                            className="googlemap-form-input"

                            value={provinceValue}
                            onChange={(e) => onTextChange(e.target.value, 'province')}
                            label="จังหวัด"
                        >
                            <MenuItem value={888} >ทุกจังหวัด</MenuItem>
                            {
                                provinceAll &&
                                provinceAll.map((item: ProvinceList, index: number) => {

                                    return (
                                        <MenuItem key={index} value={item.provinceId}>{item.provinceName} </MenuItem>

                                    )
                                })
                            }

                        </Select>
                    </FormControl>
                    {
                        provinceValue && provinceValue != "888" &&
                        <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                            <InputLabel id="googlemap-form-label">อำเภอ / เขต</InputLabel>
                            <Select
                                className="googlemap-form-input"

                                value={districtValue}
                                onChange={(e) => onTextChange(e.target.value, 'district')}
                                label="อำเภอ / เขต"
                            >
                                {
                                    distrioctSelect &&
                                    distrioctSelect.map((item: DistrictList, index: number) => {

                                        return (
                                            <MenuItem key={index} value={item.districtId}>{item.districtName} </MenuItem>

                                        )
                                    })
                                }

                            </Select>
                        </FormControl>
                    }
                    {
                        productList &&
                        <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                            <InputLabel id="googlemap-form-label">กรุณาเลือกประเภทผลิตภัณฑ์</InputLabel>
                            <Select
                                className="googlemap-form-input"

                                value={productValue}
                                onChange={(e) => onTextChange(e.target.value, 'product')}
                                label="กรุณาเลือกประเภทผลิตภัณฑ์"
                            >
                                <MenuItem value="999">ทุกผลิตภัณฑ์</MenuItem>

                                {
                                    productList &&
                                    productList.map((item: ProductListModel, index: number) => {

                                        return (
                                            <MenuItem key={index} value={item.product_category_id}>{item.product_category_name} </MenuItem>

                                        )
                                    })
                                }

                            </Select>
                        </FormControl>
                    }
                    {
                        searchResult &&
                        <FormControl variant="standard" sx={{ m: 1, minWidth: 120 }}>
                            <div className="search-result-text-control">
                                <div className="search-result-text-flex">
                                    <span className="search-result-text-title">ค้นหาทั้งหมด ({searchResult.length > 0 ? searchResult.length : 5})</span>
                                    <FontAwesomeIcon className="search-result-text-icon" icon={faSearch}></FontAwesomeIcon>
                                </div>
                                <div className="search-result-text-divider"></div>
                            </div>
                        </FormControl>

                    }


                    {
                        searchResult && markerModel ?
                            <div className="search-result-control">
                                {
                                    searchResult.length == 0 &&  recommendStoer &&
                                    recommendStoer.slice(0, 5).map((item: SearchResultModel, index: number) => {

                                        return (
                                            <div className="search-result-item-control" key={index} onClick={() => clickBranch(item, index)}>
                                                <div className="search-result-recommend-control">
                                                    <FontAwesomeIcon icon={faStar} className="search-result-recommend-icon"></FontAwesomeIcon>
                                                    <span className="search-result-recommend-badge">Store ที่แนะนำ ใกล้คุณ</span>
                                                </div>
                                                <div className="search-result-head-control">

                                                    <span className="search-result-title">{item.store_name}</span>
                                                    <div className="search-result-near-by-control">
                                                        <span className="search-result-near-by-text">{item.distance ? item.distance + " km" : 'ไม่ระบุ'}</span>
                                                        <Button className="search-result-near-by-button"

                                                            onClick={() => clicktoDirection(item.store_location_url)}>นำทาง</Button>
                                                    </div>
                                                </div>

                                                <span className="search-result-address-text">{item.store_address}</span>
                                                <span className="search-result-address-text">Tel : {item.store_contact &&
                                                    <a href={"tel:" + item.store_contact}>{item.store_contact}</a>
                                                }</span>
                                                <div className="search-result-divider"></div>
                                                <span className="search-result-product-cate">ประเภทผลิตภัณฑ์ที่มีในสาขา</span>
                                                <span className="search-result-product-cate-desc">{

                                                    (Number(productValue) == 999 && item.product_category_id && item.product_category_id.length > 0) ?

                                                        item.product_category_id.map((itemID: number, index: number) => {

                                                            return (
                                                                (item.product_category_id && index == item.product_category_id.length - 1) ?
                                                                    <span className="search-result-product-cate-desc-url" onClick={() => OpenProductUrl(itemID)} key={index}>{returnProductCategoryByID(itemID)}</span> :
                                                                    <span className="search-result-product-cate-desc-url" onClick={() => OpenProductUrl(itemID)} key={index}>{returnProductCategoryByID(itemID) + ", "}</span>
                                                            )
                                                        }) : <span className="search-result-product-cate-desc-url" onClick={() => OpenProductUrl(Number(productValue))}>{returnProductCategoryByID(Number(productValue))}</span>

                                                }</span>
                                            </div>
                                        )
                                    }
                                    )
                                }
                                {
                                    searchResult.map((item: SearchResultModel, index: number) => {

                                        return (

                                            <div className="search-result-item-control" key={index} onClick={() => clickBranch(item, index)}>
                                                {
                                                    item.store_recommend &&
                                                    <div className="search-result-recommend-control">
                                                        <FontAwesomeIcon icon={faStar} className="search-result-recommend-icon"></FontAwesomeIcon>
                                                        <span className="search-result-recommend-badge">Store ที่แนะนำ</span>
                                                    </div>
                                                }
                                                <div className="search-result-head-control">
                                                    <span className="search-result-title">{item.store_name}</span>
                                                    <div className="search-result-near-by-control">
                                                        <span className="search-result-near-by-text">{item.distance ? item.distance + " km" : 'ไม่ระบุ'}</span>
                                                        <Button className="search-result-near-by-button"

                                                            onClick={() => clicktoDirection(item.store_location_url)}>นำทาง</Button>
                                                    </div>
                                                </div>

                                                <span className="search-result-address-text">{item.store_address}</span>
                                                <span className="search-result-address-text">Tel : {item.store_contact &&
                                                    <a href={"tel:" + item.store_contact}>{item.store_contact}</a>
                                                }</span>
                                                <div className="search-result-divider"></div>
                                                <span className="search-result-product-cate">ประเภทผลิตภัณฑ์ที่มีในสาขา</span>
                                                <span className="search-result-product-cate-desc">{

                                                    (Number(productValue) == 999 && item.product_category_id && item.product_category_id.length > 0) ?

                                                        item.product_category_id.map((itemID: number, index: number) => {

                                                            return (
                                                                (item.product_category_id && index == item.product_category_id.length - 1) ?
                                                                    <span className="search-result-product-cate-desc-url" onClick={() => OpenProductUrl(itemID)} key={index}>{returnProductCategoryByID(itemID)}</span> :
                                                                    <span className="search-result-product-cate-desc-url" onClick={() => OpenProductUrl(itemID)} key={index}>{returnProductCategoryByID(itemID) + ", "}</span>
                                                            )
                                                        }) : <span className="search-result-product-cate-desc-url" onClick={() => OpenProductUrl(Number(productValue))}>{returnProductCategoryByID(Number(productValue))}</span>

                                                }</span>
                                            </div>
                                        )
                                    })
                                }
                            </div> :

                            recommendStoer && recommendStoer.length > 0 ?
                                <>


                                    <div className="search-result-control">
                                        <Divider textAlign="center">แนะนำสาขาใกล้คุณ</Divider>
                                        {
                                            recommendStoer.slice(0, 5).map((item: SearchResultModel, index: number) => {

                                                return (
                                                    <div className="search-result-item-control" key={index} onClick={() => clickBranch(item, index)}>
                                                        <div className="search-result-recommend-control">
                                                            <FontAwesomeIcon icon={faStar} className="search-result-recommend-icon"></FontAwesomeIcon>
                                                            <span className="search-result-recommend-badge">Store ที่แนะนำ ใกล้คุณ</span>
                                                        </div>
                                                        <div className="search-result-head-control">

                                                            <span className="search-result-title">{item.store_name}</span>
                                                            <div className="search-result-near-by-control">
                                                                <span className="search-result-near-by-text">{item.distance ? item.distance + " km" : 'ไม่ระบุ'}</span>
                                                                <Button className="search-result-near-by-button"

                                                                    onClick={() => clicktoDirection(item.store_location_url)}>นำทาง</Button>
                                                            </div>
                                                        </div>

                                                        <span className="search-result-address-text">{item.store_address}</span>
                                                        <span className="search-result-address-text">Tel : {item.store_contact &&
                                                            <a href={"tel:" + item.store_contact}>{item.store_contact}</a>
                                                        }</span>
                                                        <div className="search-result-divider"></div>
                                                        <span className="search-result-product-cate">ประเภทผลิตภัณฑ์ที่มีในสาขา</span>
                                                        <span className="search-result-product-cate-desc">{

                                                            (Number(productValue) == 999 && item.product_category_id && item.product_category_id.length > 0) ?

                                                                item.product_category_id.map((itemID: number, index: number) => {

                                                                    return (
                                                                        (item.product_category_id && index == item.product_category_id.length - 1) ?
                                                                            <span className="search-result-product-cate-desc-url" onClick={() => OpenProductUrl(itemID)} key={index}>{returnProductCategoryByID(itemID)}</span> :
                                                                            <span className="search-result-product-cate-desc-url" onClick={() => OpenProductUrl(itemID)} key={index}>{returnProductCategoryByID(itemID) + ", "}</span>
                                                                    )
                                                                }) : <span className="search-result-product-cate-desc-url" onClick={() => OpenProductUrl(Number(productValue))}>{returnProductCategoryByID(Number(productValue))}</span>

                                                        }</span>
                                                    </div>
                                                )
                                            })
                                        }</div>
                                </>
                                : <div className="googlemap-no-result">
                                    <img src={NO_RESULT_IMG} className="googlemap-no-result-img"></img>
                                    <span className="googlemap-no-result-text">ไม่พบข้อมูลสาขา</span>
                                </div>

                    }

                </div>
                {MapComponent()}

            </div>

        </div >
    )
}

export default IndexComponent;
